import { loadGSAP } from '../../externals/gsap.js';

export const defaults = {
  max: 15,          // max rotation in degrees
  perspective: 1000,
  scale: 1.05,
  speed: 0.4,       // animation duration in seconds
};

export default async function tilt(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const max         = parseFloat(options.max);
  const perspective = parseFloat(options.perspective);
  const scale       = parseFloat(options.scale);
  const speed       = parseFloat(options.speed);

  el.style.willChange = 'transform';

  el.addEventListener('mousemove', (e) => {
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;   // 0 → 1
    const y = (e.clientY - rect.top)  / rect.height;  // 0 → 1

    gsap.to(el, {
      rotationX:         (0.5 - y) * max * 2,
      rotationY:         (x - 0.5) * max * 2,
      scale,
      transformPerspective: perspective,
      duration: speed,
      ease: 'power2.out',
    });
  });

  el.addEventListener('mouseleave', () => {
    gsap.to(el, {
      rotationX: 0,
      rotationY: 0,
      scale: 1,
      duration: speed,
      ease: 'power2.out',
    });
  });
}
